// extracted by mini-css-extract-plugin
module.exports = {"BooksLabel":"BooksLabel_BooksLabel__XXxrW"};